import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Link,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const TermsAndConditionsModal = ({ open, onClose, onAccept }) => {
  const { t } = useTranslation("termsAndConditions");
  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleAccept = () => {
    if (checked) {
      onAccept();
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      sx={{
        color: "text.primary",
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography>{t("Terms and Conditions")}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography>{t("Effective Date: November 1, 2024")}</Typography>
      </DialogTitle>
      <DialogContent dividers
        sx={{
          color: "text.primary"
        }}
      >
        <DialogContentText
          sx={{
            color: "text.primary"
          }}
        >
          <Typography>
            {t("Welcome to CarChaser.ca...")}
          </Typography>

          <Typography>{t("1. Online Terms")}</Typography>
          <Typography>
            {t("By agreeing to these Terms...")}
          </Typography>

          <Typography>{t("2. General Conditions")}</Typography>
          <Typography>
            - {t("accurate, complete, and truthful information")}
            <br />
            - {t("refuse service")}
            <br />- {t("at least 18 years old")}
          </Typography>

          <Typography>{t("3. Vehicle Information and Seller Obligations")}</Typography>
          <Typography>
            {t("solely responsible")}
          </Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("Vehicle condition")}
            <br />- {t("Mileage, ownership history")}
          </Typography>
          <Typography>
            {t("Failure to disclose")}
          </Typography>
          <Typography>{t("You further represent and warrant that you:")}</Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("lawful ownership")}
            <br />- {t("failure to comply")}
          </Typography>

          <Typography>{t("4. Fees and Pricing")}</Typography>
          <Typography>
            - {t("Sellers must pay a")}{" "}
            <strong>
              {t("non-refundable upfront fee of $65 for a CARFAX report")}
            </strong>
            .<br />
            - {t("flat fee HST")}
            <br />- {t("fees subject to change")}
          </Typography>

          <Typography>{t("5. Auction Terms")}</Typography>
          <Typography>
            {t("acts solely as a facilitator")}
          </Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("reserve price met")}
            <br />- {t("bids are irrevocable")}
          </Typography>

          <Typography>{t("6. Third-Party Tools and Links")}</Typography>
          <Typography>
            {t("third party content")}
          </Typography>

          <Typography>{t("7. Personal Information")}</Typography>
          <Typography>
            {t("governed by privacy policy")}{" "}
            <Link href="#privacy-policy">{t("Privacy Policy")}</Link>.
          </Typography>

          <Typography>
            {t("8. Disclaimer of Warranties")}
          </Typography>
          <Typography>
            {t("as is")}
          </Typography>

          <Typography>{t("9. Indemnification")}</Typography>
          <Typography>
            {t("hold harmless")}
          </Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("Misrepresentation")}
            <br />- {t("Breaches")}
          </Typography>

          <Typography>{t("10. Arbitration Policy")}</Typography>
          <Typography>
            {t("Arbitration description")}
          </Typography>

          <Typography>{t("11. Governing Law")}</Typography>
          <Typography>
            {t("Ontario laws")}
          </Typography>

          <Typography id="privacy-policy" sx={{ mt: 4 }}>
            {t("Privacy Policy")}
          </Typography>
          <Typography>{t("Effective Date: November 1, 2024")}</Typography>
          <Typography>
            {t("Welcome to CarChaser.ca...")}
          </Typography>

          <Typography>{t("1. Information We Collect")}</Typography>
          <Typography>{t("1.1 Personal Information:")}</Typography>
          <Typography>
            {t("Personal Info detail")}
          </Typography>
          <Typography>{t("1.2 Vehicle Information:")}</Typography>
          <Typography>
            {t("Vehicle Info detail")}
          </Typography>
          <Typography>{t("1.3 Usage Data:")}</Typography>
          <Typography>
            {t("Usage Data detail")}
          </Typography>

          <Typography>{t("2. How We Use Your Information")}</Typography>
          <Typography>{t("Use Info list")}</Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("Facilitate auctions")}
            <br />
            - {t("Improve platform")}
            <br />- {t("Comply legal")}
          </Typography>

          <Typography>{t("3. Sharing Information")}</Typography>
          <Typography>{t("Sharing list")}</Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("Service Providers")}
            <br />
            - {t("Dealers")}
            <br />- {t("Legal Authorities")}
          </Typography>
          <Typography>
            {t("no sale of info")}
          </Typography>

          <Typography>{t("4. Data Security")}</Typography>
          <Typography>
            {t("Data security detail")}
          </Typography>

          <Typography>{t("5. Cookies")}</Typography>
          <Typography>
            {t("Cookies detail")}
          </Typography>

          <Typography>{t("6. User Rights")}</Typography>
          <Typography>{t("User rights list")}</Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            - {t("Access and update")}
            <br />
            - {t("Request deletion")}
            <br />- {t("Opt out")}
          </Typography>

          <Typography>{t("7. Policy Updates")}</Typography>
          <Typography>
            {t("Policy updates detail")}
          </Typography>

          <Typography>{t("8. Contact Us")}</Typography>
          <Typography>
            {t("Contact us list")}
          </Typography>
          <Typography component="div" sx={{ pl: 2 }}>
            {t("Email:")}{" "}
            <Link href="mailto:contact@carchaser.ca">contact@carchaser.ca</Link>
            <br />
            {t("Phone:")} <Link href="tel:6476896208">647-689-6208</Link>
            <br />
            {t("Address:")} 801-1275 Finch Ave W, ON Toronto M3J 0L5
          </Typography>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default TermsAndConditionsModal;